import React from 'react';
import Parse from 'parse';
import ActionList from './actionlist'
import {Button, Glyphicon, Alert} from 'react-bootstrap';

// const ROLE_TM  = "TM";
// const ROLE_APL = "APL";
// const ROLE_PL = "PL";

export default class Project extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            projectId: props.projectId,
            actionId: props.actionId,
            project: {},
            actions: [],
            currentRole: "",
            showCompleted: false,
        };
        this.toggleCompleted = this.toggleCompleted.bind(this);
    }

    async componentDidMount() {

        // let _this = this;
        let Project = Parse.Object.extend("Project");
        let projectQuery = new Parse.Query(Project);
        let project = await projectQuery.get(this.state.projectId);
        project.name = project.get("name");
        project.deleted = project.get("deleted");
        this.setState({project: project});

        let Membership = Parse.Object.extend("Membership");
        let membershipQuery = new Parse.Query(Membership);
        membershipQuery.equalTo("project", project);
        membershipQuery.equalTo("user", Parse.User.current());
        membershipQuery.first().then(membership => {
            this.setState({currentRole: membership.get("role")});
        });

        let Action = Parse.Object.extend("Action");
        let query = new Parse.Query(Action);
        query.ascending("deadline");
        query.equalTo("project", project);
        query.notEqualTo("deleted", true);
        query.include("user");
        query.include("user.info");

        let actions = await query.find();

        this.setState({
            actions: actions,
        });

        console.log("componentDidMount.setState", query);
    }
    toggleCompleted() {
        this.setState({
            showCompleted: !this.state.showCompleted
        })
    }

    render() {
        return (
            <div>
                {this.state.project.deleted && (
                    <Alert bsStyle="danger">
                        <h4>Warning</h4>
                        <p>This project has been archived.</p>
                    </Alert>
                )}
                <h2>Project
                    <small> {this.state.project.name}</small>
                    <ShowCompletedToggle showCompleted={this.state.showCompleted} toggleCompleted={this.toggleCompleted} />
                </h2>
                {
                    this.state.actions.length > 0 ? (
                        <div className="negative-margin">
                            <ActionList actions={this.state.actions} showCompleted={this.state.showCompleted} showOwner={true} role={this.state.currentRole}/>
                        </div>
                    ) : (
                        <em>No actions added yet.<br /><br /></em>
                    )
                }
            </div>
        );
    }

}

let ShowCompletedToggle = (props) => {
    return (
    <span className="pull-right" style={{cursor: 'pointer'}} onClick={props.toggleCompleted}>
        <Button bsSize="xsmall"
                bsStyle={props.showCompleted ? "success" : "default"}
        >
            {(props.showCompleted === "completed") ? (
                <Glyphicon glyph="ok" style={{color: "#fff"}}/>
            ) : (
                <Glyphicon glyph="ok" style={{color: "#ccc"}}/>
            )}
        </Button>
        <span style={{fontSize: '10pt', color: '#aaa', paddingTop: '5px'}}>
            &nbsp;Show completed
        </span>
    </span>)
}


// WEBPACK FOOTER //
// ./src/project.js